import React from "react";
import './detailIndicator.scss';

export default class DetailIndicator extends React.Component {
    render() {
        const indicator = this.renderIndicator('line-border', this.props.index, this.props.columns, true);
        const indicatorShadow = this.renderIndicator('shadow', this.props.index, this.props.columns);
        const className = 'detail-indicator' + (this.props.transitionArrow ? ' tran' : '');
        return (
            <div className={className}>
                {indicatorShadow}
                {indicator}
            </div>
        );
    }
    renderIndicator(className, index, columns, hasFiller) {
        const middlePartHalfWidth = 30;
        const itemWidth = 100 / columns;
        const idx = index % columns;
        const leftPartWidth = (idx + 0.5) * itemWidth;
        const leftPartStyle = {
            width: `calc(${leftPartWidth}% - ${middlePartHalfWidth}px)`
        }

        const middlePartWidth = middlePartHalfWidth * 2 + 1;
        const middlePartStyle = {
            width: middlePartWidth + 'px'
        }

        const arrowFiller = hasFiller ? this.renderArrowFiller(middlePartWidth) : null;

        return (
            <div className={'indicator-line ' + className}>
                <div className='left-edge'>
                    <svg width="100%" height="20">
                        <line x1="0%" y1="19" x2="100%" y2="19" />
                    </svg>
                </div>
                <div className='container'>
                    <div className='row'>
                        <div className='indicator'>
                            <div className='left-part' style={leftPartStyle}>
                                <svg width="100%" height="20">
                                    <line x1="0%" y1="19" x2="100%" y2="19" />
                                </svg>
                            </div>
                            <div className='middle-part' style={middlePartStyle}>
                                <svg width={middlePartWidth} height="20" viewBox="0 0 61 20">
                                    <path d="M 0 19 L 15 19 L 31 3 L 47 19 L 61 19" />
                                </svg>
                                {arrowFiller}
                            </div>
                            <div className='right-part'>
                                <svg width="100%" height="20">
                                    <line x1="0%" y1="19" x2="100%" y2="19" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-edge'>
                    <svg width="100%" height="20">
                        <line x1="0%" y1="19" x2="100%" y2="19" />
                    </svg>
                </div>
            </div>
        );
    }

    renderArrowFiller(middlePartWidth) {
        return (
            <svg className='arrow-filler' width={middlePartWidth} height="20" viewBox="0 0 61 20">
                <path d="M 15 19 L 31 3 L 47 19 Z" />
            </svg>
        );
    }
}